<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Exportar Histórico de Consultas
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form :action="$store.state.url + 'export/requests_history'" id="export">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="carDateStart">
                            <span class="required">*</span> Data Início
                          </label>
                          <input type="date" v-model="reserveVehicles.RetreatDatetime" class="form-control"
                            name="retreat_date" id="retreat_date" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="carDateEnd">
                            <span class="required">*</span> Data Final
                          </label>
                          <input type="date" v-model="reserveVehicles.DevolutionDatetime" class="form-control"
                            name="devolution_date" id="devolution_date" />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="block text-right">
                      <a @click="checkForm" class="btn btn-add">
                        Exportar em Excel
                        <i class="fas fa-file-export"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  data() {
    return {
      reserveVehicles: {
        RetreatDatetime: "",
        DevolutionDatetime: "",
      },
      reserveStatus: [],
    };
  },
  methods: {
    checkForm: function () {
      var data_1 = new Date(this.reserveVehicles.RetreatDatetime);
      var data_2 = new Date(this.reserveVehicles.DevolutionDatetime);

      if (
        this.reserveVehicles.RetreatDatetime == "" ||
        this.reserveVehicles.DevolutionDatetime == "" ||
        this.reserveVehicles.reserve_status == ""
      ) {
        swal("Erro", "Os dados do formulário não podem ser vazios", "error");
      } else {
        if (data_1 > data_2) {
          swal(
            "Erro",
            "Data inicial não pode ser maior que data final",
            "error"
          );
        } else {
          this.extract();
          //document.getElementById("export").submit();
        }
      }
    },
    extract(extraction) {

      $("#page_loader").show();
      const self = this;
      const api = self.$store.state.api + "export/requests_history"



      self.$http.post(api, {
        retreat_date: self.reserveVehicles.RetreatDatetime,
        devolution_date: self.reserveVehicles.DevolutionDatetime,
        reserve_status: self.reserveVehicles.reserve_status,
        uid: self.$store.state.user.id
      })
        .then(response => {
          $("#page_loader").hide();
          window.open(
            self.$store.state.url +
            "downloadExtractByHash/" +
            response.data,
            "_blank"
          );
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
  },
  mounted: function () {
    const self = this;
  },
  components: {
    CtkDateTimePicker,
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Exportation/Requests.vue